import CTA9 from './CTA9'
export default CTA9
